var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state-box"},[_c('h4',[_vm._v(_vm._s(_vm.head))]),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.type == "money" ? "£" + _vm.numberWithCommas(_vm.state) : _vm.state))])])])}
var staticRenderFns = []

export { render, staticRenderFns }